import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchCubicCapacitymaster,
  selectCubicCapacity,
  setDataSuccess
} from 'src/features/staticDataSlice';
import CubicCapacityCreateModal from 'src/pages/PolicyProduct/RiskFactor/CubicCapacity/CubicCapacityCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function CubicCapacityList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [cubicCapacityCreatePermission, setCubicCapacityCreatePermission] = useState(false);

  const cubicCapacityData = useSelector(selectCubicCapacity);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setCubicCapacityCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('cubicCapacity', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchCubicCapacitymaster(productId).then(data =>
      dispatch(setDataSuccess({ dataType: 'cubicCapacity', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Plug in validation if required

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-cubicCapacity" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-cubicCapacity"
          id="select-cubicCapacity"
          value={tableListDatas[index]?.cubicCapacity || ''}
          onChange={(event) => {
            handleChange('cubicCapacity', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {cubicCapacityData?.map((cubicCapacity) => (
            <MenuItem key={cubicCapacity?.range} value={cubicCapacity?.range}>
              {cubicCapacity?.range}
            </MenuItem>
          ))}
          <Tooltip
            title={
              cubicCapacityCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Cubic Capacity
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (cubicCapacityCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: cubicCapacityCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <CubicCapacityCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default CubicCapacityList;
